/* eslint-disable */
import { useEffect, useState } from "react";
import { Box, styled, ButtonGroup, Button, Typography, Grid, Tabs, Tab, Card, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import AddIcon from "@mui/icons-material/Add";
import GoogleAndKeywordFeatureTable from "./GoogleAndKeywordFeatureTable";
import AddKeywordForm from "./AddKeywordForm";
import { deleteKeyword } from "../../gql/queries/keywordsRanking";
import { usePopup } from "../../context/commonPop";
import CurrentSearchResultRankings from "./CurrentSearchResultRankings";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .MuiButtonGroup-root": {
    "& button": {
      minWidth: "86px",
      borderRight: "1px solid #E3E3E3 !important",
      border: "none",
      borderRadius: "0",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "1",
      textAlign: "center",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
      padding: "10px",
      color: theme.palette.text.primary,
      "&:first-of-type": {
        borderTopLeftRadius: "50px",
        borderBottomLeftRadius: "50px",
      },
      "&:last-of-type": {
        borderTopRightRadius: "50px",
        borderBottomRightRadius: "50px",
        border: "none !important",
      },
      "&:focus": {
        outline: "none",
      },
      "&.active": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
      "&:hover": {
        color: "#fff",
      },
    },
  },

  "& .filterText": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& p": {
      textAlign: "center",
      minWidth: "85px",
      color: "#7F7F7F",
      "&.novalue": {
        color: "#fff",
      },
      "&:first-of-type": {
        color: theme.palette.mode === "dark" ? "#ffffff !important" : "#2A3547 !important",
        fontWeight: 500,
        lineHeight: "1",
        textAlign: "center",
      },
    },
  },
  "& .btnGroupWrapper": {
    border: "1px solid #E3E3E3",
    padding: "2px",
    borderRadius: "50px",
    margin: "8px 0",
    "& .Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "& .MuiTabs-indicator": {
        display: "none",
      },
    },
    "& .MuiTabs-root": {
      minHeight: "38px",
      "& button": {
        minHeight: "38px",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "#ffffff",
        },
      },
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "@media screen and (max-width:600px)": {
      display: "flex",
      flexWrap: "nowrap",
      overflowX: "scroll",
      width: "100%",
    },
  },
  "& .addKeyword": {
    textAlign: "start",
    "& a": {
      width: "100%",
    },
    "& button": {
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      "@media screen and (max-width:600px)": {
        width: "100%",
      },
      "& a": {
        color: theme.palette.common.textColor,
        width: "100%",
        "&:hover": { textDecoration: "none" },
      },
      "&:hover": {
        backgroundColor: theme.palette.common.hoverBtn,
        color: theme.palette.common.white,
        "& a": {
          color: theme.palette.common.white,
        },
      },
    },
  },
  "& .btnGroupBox": {
    "@media screen and (max-width:1500px)": {
      overflowX: "scroll",
      width: "100%",
    },
  },
}));
const buttonArray = ["All", "Top 01", "Top 03", "Top 05", "Top 10", "Top 30", "Top 100", ">100"];
const filters = ["Top 1", "Top 3", "Top 5", "Top 10", "Top 30", "Top 100", ">100"];
const PositionFilterHead = ({ domain, rankingData, dropDownValue, setDropDownValue, search, setSearch, filterPercentage, filterCount, handleBlogGenerator, disabled }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [filteredRankingData, setFilteredRankingData] = useState([]);
  const [open, setOpen] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [maxActiveIcons, setMaxActiveIcons] = useState(0);
  const [modelOpen, setModelOpen] = useState(false);
  const [queryObj, setQueryObj] = useState(null);
  const { handleOpen } = usePopup();
  const [DELETE_QUERY] = useLazyQuery(deleteKeyword, { fetchPolicy: "network-only" });

  useEffect(() => {
    if (rankingData && rankingData.isoDates && rankingData.rows) {
      const isoDates = rankingData.isoDates || [];
      const rows = rankingData.rows || [];
      const filterData = tabIndex => {
        if (tabIndex === 0) {
          return rows;
        }

        const rangeEnd = parseInt(buttonArray[tabIndex]?.split(" ")[1], 10) || Infinity;
        const rangeStart = tabIndex === buttonArray.length - 1 ? 101 : 0;

        return rows.filter(row => isoDates.some(date => row[date] > rangeStart && row[date] <= rangeEnd));
      };

      setFilteredRankingData({
        rows: filterData(selectedTab),
        columns: rankingData?.columns,
        isoDates: rankingData?.isoDates,
        averageGraphData: rankingData?.averageData,
        rankCounts: rankingData?.rankCounts,
        rankPercentages: rankingData?.rankPercentages,
      });
    } else {
      console.error("Invalid or missing rankingData, isoDates, or rows.");
      setFilteredRankingData([]);
    }
  }, [rankingData, selectedTab]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleCheckboxChange = (event, rowIndex) => {
    setCheckedRows(prev => {
      const updatedRows = [...prev];
      updatedRows[rowIndex] = {
        ...updatedRows[rowIndex],
        checked: event.target.checked,
      };

      return updatedRows;
    });
  };

  const countActiveIcons = row => {
    let activeCount = 0;
    if (row?.cse_image?.[0]?.src) activeCount++;
    if (row?.cse_video?.[0]?.src) activeCount++;
    if (row?.cse_thumbnail?.[0]?.src) activeCount++;
    return activeCount;
  };

  const handleDelete = () => {
    DELETE_QUERY({
      variables: { domain: domain, keyword: queryObj?.keyword },
      onCompleted: ({ deleteKeyword }) => {
        handleOpen(true, "Keyword deleted successfully");
      },
      onError(err) {
        handleOpen(true, "Something went wrong please wait some time");
      },
    });

    const updatedRows = filteredRankingData.rows.filter(row => row.id !== queryObj.id);
    setFilteredRankingData(prevData => ({
      ...prevData,
      rows: updatedRows,
    }));
    setQueryObj(null);
    setModelOpen(false);
  };

  useEffect(() => {
    if (rankingData?.rows) {
      const newRowsArray = rankingData.rows.map(row => {
        const dateEntries = Object.keys(row)
          .filter(key => /\d{4}-\d{2}-\d{2}/.test(key))
          .map(dateKey => ({
            date: dateKey,
            rank: row[dateKey],
          }));
        const keyword = row.keywords || "defaultKeyword";
        return {
          checked: false,
          keyword: keyword,
          dates: dateEntries.map(item => item.date),
          ranks: dateEntries.map(item => item.rank),
        };
      });

      setCheckedRows(newRowsArray);
    }
  }, [rankingData]);
  const theme = useTheme();
  return (
    <BoxWrapper>
      <Grid container spacing={2} sx={{ justifyContent: "space-between", alignItems: "center" }}>
        <Grid item xs={12} md={12}>
          {/* <Box className="addKeyword">
              <Button variant="contained" onClick={() => setOpen(true)}>
                <AddIcon />
                Add Keywords
              </Button>
          </Box> */}

          <Box className="addKeyword" py={2}>
            <Button onClick={handleBlogGenerator} disabled={disabled}>
              <AddIcon />
              Generate blog
            </Button>
          </Box>
        </Grid>
        {/* <Grid container spacing={2} sx={{ alignItems: "center" }}> */}
        <Grid item xs={12} md={7.5}>
          <Card sx={{ border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", display: "flex", alignItems: "center", minHeight: "206.72px" }}>
            <ButtonGroup aria-label="Button Group" className="btnGroupBox">
              <Box>
                <Box className="filterText">
                  <Typography component={"p"}>Position filters:</Typography>
                  {filterPercentage &&
                    filterPercentage.map((data, index) => (
                      <Typography key={index} component={"p"}>
                        {data}
                      </Typography>
                    ))}
                </Box>
                <Box className="btnGroupWrapper">
                  <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="position filter tabs">
                    {buttonArray.map((item, index) => (
                      <Tab key={`tab-${index}`} label={item} />
                    ))}
                  </Tabs>
                </Box>
                <Box className="filterText">
                  <Typography component={"p"}>{(rankingData?.rows && rankingData?.rows.length) || 0}</Typography>
                  {filterCount &&
                    filterCount.map((data, index) => (
                      <Typography key={index} component={"p"}>
                        {data}
                      </Typography>
                    ))}
                </Box>
              </Box>
            </ButtonGroup>
          </Card>
        </Grid>
        <Grid item xs={12} md={4.5}>
          <CurrentSearchResultRankings rankingData={rankingData} />
        </Grid>
        {/* </Grid> */}

        <Grid item xs={12}>
          <GoogleAndKeywordFeatureTable
            rankingData={filteredRankingData}
            dropDownValue={dropDownValue}
            setDropDownValue={setDropDownValue}
            search={search}
            setSearch={setSearch}
            handleCheckboxChange={handleCheckboxChange}
            checkedRows={checkedRows}
            countActiveIcons={countActiveIcons}
            setMaxActiveIcons={setMaxActiveIcons}
            maxActiveIcons={maxActiveIcons}
            modelOpen={modelOpen}
            setModelOpen={setModelOpen}
            handleDelete={handleDelete}
            queryObj={queryObj}
            setQueryObj={setQueryObj}
          />
        </Grid>
      </Grid>
      <AddKeywordForm open={open} setOpen={setOpen} domain={domain} />
    </BoxWrapper>
  );
};

export default PositionFilterHead;
